"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Estimate() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: photoRef,
    isVisible: photoVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: circleRef,
    isVisible: circleVisible
  } = useRevealOnScroll<SVGSVGElement>({
    threshold: 0.3
  });
  const {
    ref: arrowRef,
    isVisible: arrowVisible
  } = useRevealOnScroll<SVGSVGElement>({
    threshold: 0.3
  });
  return <section data-section-id="20474" id="get-a-free-bathroom-remodel-estimate" className="dark bg-background text-foreground py-28 md:py-40 px-5 md:px-10 lg:px-14 overflow-hidden relative">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-center">
          {}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <div ref={eyebrowRef} className="mb-6 transition-all duration-[620ms] ease-out" style={{
            opacity: eyebrowVisible ? 1 : 0,
            transform: eyebrowVisible ? "translateY(0)" : "translateY(14px)"
          }}>
              <span className="font-mono text-xl md:text-2xl inline-block" style={{
              color: "var(--primary)",
              transform: "rotate(-3deg)"
            }}>Bathroom Remodel Lakeland FL</span>
            </div>

            <h2 ref={headingRef} className="font-default font-semibold text-[clamp(2rem,3.6vw,3.5rem)] leading-[1.08] tracking-tight text-foreground transition-all duration-[620ms] ease-out" style={{
            opacity: headingVisible ? 1 : 0,
            transform: headingVisible ? "translateY(0)" : "translateY(14px)",
            transitionDelay: "80ms"
          }}>Request a Bathroom Remodel Quote in Lakeland, FL</h2>

            <p ref={bodyRef} className="mt-8 font-default text-[clamp(1.0625rem,1.1vw,1.1875rem)] leading-[1.6] text-secondary-foreground max-w-xl transition-all duration-[620ms] ease-out" style={{
            opacity: bodyVisible ? 1 : 0,
            transform: bodyVisible ? "translateY(0)" : "translateY(14px)",
            transitionDelay: "160ms"
          }}>Request a free bathroom remodel quote in Lakeland, FL. Get help with bathroom updates, renovations, showers, tubs, tile, flooring, vanities, fixtures, and layout improvements.<div><br /></div></p>

            <div ref={ctaRef} className="mt-10 flex flex-col sm:flex-row gap-4 items-stretch sm:items-center transition-all duration-[620ms] ease-out" style={{
            opacity: ctaVisible ? 1 : 0,
            transform: ctaVisible ? "translateY(0)" : "translateY(14px)",
            transitionDelay: "240ms"
          }}>
              <Link to="/contact" className="w-full sm:w-auto">
                <Button className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 font-default font-semibold rounded-lg px-7 py-3.5 h-auto text-base shadow-md">Request a Free Quote</Button>
              </Link>
              <Link to="/services" className="w-full sm:w-auto">
                <Button variant="outline" className="w-full sm:w-auto bg-transparent border-[1.5px] border-foreground text-foreground hover:bg-foreground hover:text-background font-default font-semibold rounded-lg px-7 py-3.5 h-auto text-base">
                  View our services
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 order-1 lg:order-2 relative">
            <div ref={photoRef} className="relative mx-auto max-w-md lg:max-w-none transition-all duration-[700ms] ease-out" style={{
            opacity: photoVisible ? 1 : 0,
            transform: photoVisible ? "translateY(0) rotate(1.8deg)" : "translateY(14px) rotate(1.8deg)"
          }}>
              <div className="overflow-hidden bg-card shadow-2xl" style={{
              borderRadius: "14px"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/modern_bathroom_remodel_lakeland.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/modern_bathroom_remodel_lakeland.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/modern_bathroom_remodel_lakeland.png-wvc-sizes" alt="A beautifully renovated modern bathroom in a Lakeland home" className="w-full h-auto block object-cover aspect-[4/5]" loading="lazy" decoding="async" />
              </div>
              <p className="mt-4 font-mono text-lg md:text-xl text-secondary-foreground text-center px-4 !w-[489.539px] !h-[78.0469px]" style={{
              transform: "rotate(-1.5deg)"
            }}>Bathroom remodel ideas for Lakeland, FL<br /></p>

              {}
              <svg ref={arrowRef} className="hidden lg:block absolute pointer-events-none" style={{
              bottom: "-80px",
              left: "-180px",
              width: "240px",
              height: "140px"
            }} viewBox="0 0 240 140" fill="none" aria-hidden="true">
                <path d="M 220 20 C 160 30, 100 50, 60 80 C 40 95, 25 110, 18 122" stroke="var(--secondary)" strokeWidth="2" strokeLinecap="round" fill="none" style={{
                strokeDasharray: 400,
                strokeDashoffset: arrowVisible ? 0 : 400,
                transition: "stroke-dashoffset 1100ms ease-out 400ms"
              }} />
                <path d="M 18 122 L 28 114 M 18 122 L 26 132" stroke="var(--secondary)" strokeWidth="2" strokeLinecap="round" fill="none" style={{
                strokeDasharray: 30,
                strokeDashoffset: arrowVisible ? 0 : 30,
                transition: "stroke-dashoffset 300ms ease-out 1400ms"
              }} />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>;
}